import React                    from 'react';
import PropTypes                from 'prop-types';
import {unmountComponentAtNode} from 'react-dom';
import Modal                    from '../Modal';
import Flux                     from '../../flux/Flux';
import Translations             from '../../utils/Translations';

class ModalBoxContests extends React.Component {

	static validateEmail(email) {
		const re = Flux.Constants.RegExp.EMAIL;
		return re.test(email);
	}

	constructor(props) {
		super(props);
		this.state = {
			emailValidationError: false,
			isSubscribed:         false,
			requestError:         false,
			sending:              false,
		};

		this.emailInput = null;

		this.onClose                = this.onClose.bind(this);
		this.onNewsletterSubscribed = this.onNewsletterSubscribed.bind(this);
		this.onSendClick            = this.onSendClick.bind(this);
		this.unsetEmailError        = this.unsetEmailError.bind(this);
	}

	componentDidMount() {
		Flux.Guest.addNewsletterSubscribedListener(this.onNewsletterSubscribed);
	}

	componentWillUnmount() {
		Flux.Guest.removeNewsletterSubscribedListener(this.onNewsletterSubscribed);
	}

	onClose() {
		if (this.props.containerId) {
			unmountComponentAtNode(document.getElementById(this.props.containerId));
		}

		if (this.props.onClose) {
			this.props.onClose();
		}
	}

	onNewsletterSubscribed(success, typeId) {
		if (typeId ===  Flux.Constants.NewsletterTypes.CONTESTS) {
			if (success) {
				this.setState({
					isSubscribed: true,
					sending:      false,
				});
			} else {
				this.setState({
					requestError: true,
					sending:      false,
				});
			}
		}
	}

	onSendClick() {
		//const email        = this.emailInput.value;
		const isEmailValid = true; //|| ModalBoxContests.validateEmail(email) || email === '';   // disabling the check temporarily
		if (!isEmailValid) {
			this.setState({
				emailValidationError: true,
			});
		} else {
			this.setState({
				requestError: false,
				isSubscribed: false,
				sending:      true,
			});

			Flux.Guest.subscribeNewsletter(Flux.Constants.NewsletterTypes.CONTESTS);
		}
	}

	unsetEmailError() {
		this.setState({
			emailValidationError: false,
		});
	}

	render() {
		return (
			<Modal containerWidth={650}
			       dynamicSize={true}
			       className="-theme-dialog -no-padding -relative"
			       onClose={this.onClose}
			       showSpinner={this.state.sending}
			>
				<div>
					<div className={'contests__modal__content-container ' + (this.props.isMobile ? '-mobile' : '')}>
						<div className="contests__modal__icon icon -icon-envelope-full" />
						<div className="contests__modal__header-container">
							<div className="contests__modal__headline1">
								{Translations.get('ModalContestsHeadline1')}
							</div>
							<div className="contests__modal__headline2">
								{Translations.get('ModalContestsHeadline2')}
							</div>
						</div>
						<div>
							<div className="contests__modal__input-container">
								<input className="contests__modal__input"
								       ref={input => {
									       this.emailInput = input;
								       }}
								       type="text"
								       defaultValue={Flux.Guest.getEmailAddress()}
								       placeholder={Translations.get('SurveyFeedbackEmailPlaceholder')}
								       onFocus={this.unsetEmailError}
								       readOnly={true}
								/>
								{this.state.emailValidationError &&
								<div className="contests__modal__input-error">{Translations.get('ModalContestsEmailValidationError')}</div>}
							</div>
							<button disabled={this.state.isSubscribed} className={"contests__modal__subscribe-btn btn -btn-color-special -click-material" + (this.state.isSubscribed ? " -disabled" : null) }
							        onClick={this.onSendClick}
							>{Translations.get('ModalContestsEmailSubscribeButton')}
							</button>
						</div>
						{this.state.isSubscribed && <div className="contests__modal__confirmation-container">
							<div className="contests__modal__confirmation__headline">
								{Translations.get('ModalContestsConfirmationHeadline')}
							</div>
							<div className="contests__modal__confirmation">
								{Translations.get('ModalContestsConfirmation')}
							</div>
						</div>}
						{this.state.requestError && <div className="contests__modal__request-error">
							{Translations.get('ModalContestsRequestError')}
						</div>}
					</div>
				</div>
			</Modal>);
	}
}

ModalBoxContests.propTypes = {
	containerId: PropTypes.string,
	isMobile:    PropTypes.bool,
	onClose:     PropTypes.func,
};

ModalBoxContests.defaultProps = {
	isMobile: false,
};

export default ModalBoxContests;
